import { render, staticRenderFns } from "./bird-friendly-learning-trail.vue?vue&type=template&id=577715ca&scoped=true&"
import script from "./bird-friendly-learning-trail.vue?vue&type=script&lang=js&"
export * from "./bird-friendly-learning-trail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577715ca",
  null
  
)

export default component.exports